import { gql } from "@outschool/ui-apollo";

import { ActivityListingFragment } from "../../Listings/graphql/fragments";
import { SavedActivityFragment } from "./fragments";

export const SavedClassListQuery = gql`
  query SavedClassListQuery(
    $listUid: String
    $order: String
    $searchFilters: SearchFilters!
    $limit: Int
    $offset: Int
    $skipRating: Boolean!
    $skipSavedActivities: Boolean
    $showListsForUserAndLearners: Boolean
  ) {
    savedClassList(
      listUid: $listUid
      order: $order
      skipSavedActivities: $skipSavedActivities
    ) {
      uid
      name
      privacyStatus
      ownerUid
      activityCount(countForUserAndLearnerLists: $showListsForUserAndLearners)
      listings(
        searchFilters: $searchFilters
        limit: $limit
        offset: $offset
        showListsForUserAndLearners: $showListsForUserAndLearners
      ) {
        ...ActivityListing_listing
      }
      owner {
        uid
        publicName
        leader {
          uid
          leader_link
        }
      }
    }
    currentUser {
      uid
      learners {
        uid
        name
        savedClassList {
          uid
        }
      }
      savedClassLists {
        uid
      }
      userDefaultSavedClassList {
        uid
      }
    }
  }
  ${ActivityListingFragment}
`;

export const CurrentUserSavedActivitiesQueryStr = gql`
  query CurrentUserSavedActivities {
    currentUser {
      uid
      savedActivities {
        uid
        ...SavedActivityFragment
      }
    }
  }
  ${SavedActivityFragment}
`;

export const ListCurrentUserSavedClassLists = gql`
  query ListCurrentUserSavedClassLists {
    currentUser {
      uid
      savedClassLists {
        uid
        name
        lastAddedToAt
      }
    }
  }
`;

export const ListSavedClassesWithPhotos = gql`
  query ListSavedClassesWithPhotos {
    currentUser {
      uid
      savedClassLists {
        __typename
        uid
        name
        lastAddedToAt
        listings(searchFilters: { order: "saved" }, limit: 1, offset: 0) {
          activity {
            details {
              photo
            }
          }
        }
      }
    }
    savedClassList {
      __typename
      uid
      lastAddedToAt
      listings(searchFilters: { order: "saved" }, limit: 1, offset: 0) {
        activity {
          details {
            photo
          }
        }
      }
    }
  }
`;
